import { ArrowUpRight, Instagram } from "lucide-react";
import { Reveal, SectionBadge } from "./Shared";
import { PHONE, PHONE_LINK, EMAIL, INSTAGRAM, INSTAGRAM_LINK } from "../data";

export default function Footer() {
  return (
    <footer id="contact" className="relative overflow-hidden bg-leaf pt-24 text-cream md:pt-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <SectionBadge light>08 — Say Hello</SectionBadge>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif text-6xl font-medium leading-[0.9] tracking-tighter md:text-9xl">
            Thirsty?
            <br />
            <span className="font-cursive font-bold text-sun">Call the Squeeze.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-base font-light leading-relaxed text-cream/75">
            Fresh batches pressed daily. Call, text or email to reserve your
            juices, shots or cleanse — we'll have them cold and waiting.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-14 flex flex-col gap-6 border-t border-cream/15 pt-10">
            <a
              href={PHONE_LINK}
              data-testid="contact-phone-link"
              className="group flex w-fit items-center gap-4 font-serif text-4xl font-medium tracking-tight transition-colors duration-300 hover:text-sun md:text-6xl"
            >
              {PHONE}
              <ArrowUpRight className="h-8 w-8 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 md:h-12 md:w-12" />
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-link"
              className="group flex w-fit items-center gap-4 font-serif text-3xl font-medium tracking-tight transition-colors duration-300 hover:text-sun md:text-5xl"
            >
              {EMAIL}
              <ArrowUpRight className="h-7 w-7 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 md:h-10 md:w-10" />
            </a>
            <a
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram-link"
              className="group mt-2 flex w-fit items-center gap-3 text-lg font-light tracking-wide text-cream/80 transition-colors duration-300 hover:text-sun"
            >
              <Instagram className="h-5 w-5" />
              {INSTAGRAM}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>

        <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-cream/15 py-8 text-[10px] font-medium uppercase tracking-[0.25em] text-cream/60">
          <span className="flex items-center gap-2">
            <img src="/images/logo.png" alt="Main Squeeze logo" className="h-8 w-8 rounded-full object-cover" />
            © 2026 Main Squeeze
          </span>
          <span data-testid="footer-tagline">Freshly Made • Natural Ingredients • Juiced With Love</span>
        </div>
      </div>

      <p className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[18vw] font-bold leading-none text-outline-cream">
        Main Squeeze
      </p>
    </footer>
  );
}
